enum COMPARED_TO_SETTINGS {
    CHAIN = 1,
    MARKET,
}

export default COMPARED_TO_SETTINGS;
